import axios from 'axios';
import moment from 'moment';
import { NotificationManager } from "../components/common/react-notifications";
import { defaultDirection } from "../constants/defaultValues";
import { firestore, functions, storage } from './Firebase';

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key], B = b[key];
    if (order.indexOf(A + "") > order.indexOf(B + "")) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};


export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return dd + '.' + mm + '.' + yyyy;
}

export const getCurrentTime = () => {
  const now = new Date();
  return now.getHours() + ":" + now.getMinutes()
}

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem("direction")) {
    const localValue = localStorage.getItem("direction");
    if (localValue === "rtl" || localValue === "ltr") {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === "rtl"
  };
};

export const setDirection = localValue => {
  let direction = "ltr";
  if (localValue === "rtl" || localValue === "ltr") {
    direction = localValue;
  }
  localStorage.setItem("direction", direction);
};
export const deviceWidth = () => {
  const width = window.innerWidth;
  const breakpoint = 820;
  return width < breakpoint ? 'mobile' : 'desktop';
}
export function getFirstCharacters(string) {
  if (!string) {
    return ''
  }
  let extractedString = [];
  const words = string?.split(" ");
  for (let i = 0; i < words.length; i++) {
    const firstChar = words[i].trim()[0]?.toUpperCase();
    if (firstChar) {
      extractedString.push(firstChar);
      if (extractedString.length === 2) {
        break;
      }
    }
  }
  return extractedString.join("");
}
export const createNotification = (className, msg, title) => {
  let cName = className || "";

  switch (className) {
    case "primary":
      return NotificationManager.primary(
        title,
        msg,
        3000,
        null,
        null,
        cName
      );
    case "secondary":
      return NotificationManager.secondary(
        title,
        msg,
        3000,
        null,
        null,
        cName
      );
    case "info":
      return NotificationManager.info(title, msg, 3000, null, null, cName);
    case "success":
      return NotificationManager.success(
        title,
        msg,
        3000,
        null,
        null,
        cName
      );
    case "warning":
      return NotificationManager.warning(
        title,
        msg,
        3000,
        null,
        null,
        cName
      );
    case "error":
      return NotificationManager.error(
        msg,
        title,
        6000,
        null,
        cName
      )
    default:
      NotificationManager.info("Info message");
      break;
  }
};
export function makeid(length) {
  var result = Math.floor(Math.random(new Date().getTime()) * 90000000) + 10000000
  return result;
}

export async function getPlaceId(lat, Lng) {
  const result = await axios.get(`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${Lng}&zoom=21&format=jsonv2&addressdetails=1`);
  let place_id = result?.data?.place_id

  const result2 = await axios.get(`https://nominatim.openstreetmap.org/details.php?place_id=${place_id}&addressdetails=1&format=json`);
  // let data = result2?.data?.address?.find(r => ['boundary', 'place'].includes(r.class) && ['town', 'suburb', 'administrative', 'neighbourhood'].includes(r.type));
  let data = result2?.data?.address?.find(r => ['boundary', 'place', 'aeroway'].includes(r.class) && ['town', 'suburb', 'administrative', 'neighbourhood', 'aerodrome', 'residential'].includes(r.type));


  return data?.place_id;
}
export const accessTypes = [
  "superAdmin", "finance", "customerService", "marketing"
]

export const accessTypesObject = {
  "superAdmin": { name: 'Super admin' },
  "finance": { name: 'Finance' },
  "customerService": { name: 'Customer Service' },
  'admin': { name: 'Provider' },
  'marketing': { name: 'Marketing' },
  'washer': { name: 'Worker' },
}
export const accessTypesArray = [
  'Super admin',
  'Admin',
  'Finance',
  'Customer Service',
  'Marketing',
  'Provider',
]
export const sortTimings = (timings) => {
  const sorter = {
    "saturday": 1,
    "sunday": 2,
    "monday": 3,
    "tuesday": 4,
    "wednesday": 5,
    "thursday": 6,
    "friday": 7,
  };

  let tmp = [];
  Object.keys(timings).forEach(function (key) {
    let value = timings[key];
    let index = sorter[key.toLowerCase()];
    tmp[index] = {
      key: key,
      value: value
    };
  });

  let orderedData = {};
  tmp.forEach(function (obj) {
    orderedData[obj.key] = obj.value;
  });
  return orderedData
}

export const colors = [{ key: 1, value: 'White', label: 'White' }, { key: 2, value: 'Silver', label: 'Silver' }, { key: 3, value: 'Grey', label: 'Grey' }, { key: 4, value: 'Black', label: 'Black' }, { key: 5, value: 'Yellow', label: 'Yellow' }, { key: 6, value: 'Brown', label: 'Brown' }, { key: 7, value: 'Red', label: 'Red' }, { key: 8, value: 'Green', label: 'Green' }, { key: 9, value: 'Blue', label: 'Blue' }, { key: 10, value: 'Burgundy', label: 'Burgundy' }, { key: 11, value: 'Gold', label: 'Gold' }, { key: 12, value: 'Orange', label: 'Orange' }, { key: 13, value: 'Purple', label: 'Purple' }, { key: 14, value: 'Tan', label: 'Tan' }, { key: 15, value: 'Other', label: 'Other' }]
export const emirates = [{ key: 1, value: 'Abu Dhabi', label: 'Abu Dhabi' }, { key: 2, value: 'Ajman', label: 'Ajman' }, { key: 3, value: 'Dubai', label: 'Dubai' }, { key: 4, value: 'Fujairah', label: 'Fujairah' }, { key: 5, value: 'Ras Al Khaimah', label: 'Ras Al Khaimah' }, { key: 6, value: 'Sharjah', label: 'Sharjah' }, { key: 7, value: 'Umm Al Quwain', label: 'Umm Al Quwain' }]

export function deepCompareArray(a, b) {
  if (a === b) {
    return true;
  }

  if (a == null || b == null || a.length !== b.length) {
    return false;
  }

  // Sort arrays to ensure same order
  a = a.sort();
  b = b.sort();

  for (let i = 0; i < a.length; i++) {
    if (typeof a[i] !== typeof b[i]) {
      return false;
    }
    if (typeof a[i] === 'object') {
      if (!deepCompareObjects(a[i], b[i])) {
        return false;
      }
    } else if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

function deepCompareObjects(a, b) {
  if (a === b) {
    return true;
  }

  if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') {
    return false;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    if (!b.hasOwnProperty(key)) {
      return false;
    }
    if (typeof a[key] === 'object') {
      if (!deepCompareObjects(a[key], b[key])) {
        return false;
      }
    } else if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}


export function deepCompare(arr1, arr2) {
  const diffs = [];

  arr1.forEach((obj1) => {
    const obj2 = arr2.find((o) => deepEquals(o, obj1));
    if (!obj2) {
      diffs.push({ ...obj1, origin: 'oldVehicle' });
    }
  });

  arr2.forEach((obj2) => {
    const obj1 = arr1.find((o) => deepEquals(o, obj2));
    if (!obj1) {
      diffs.push({ ...obj2, origin: 'newVehicle' });
    }
  });

  return diffs;
}

function deepEquals(a, b) {
  if (a === b) {
    return true;
  }

  if (a == null || typeof (a) != "object" || b == null || typeof (b) != "object") {
    return false;
  }

  const keysA = Object.keys(a).sort();
  const keysB = Object.keys(b).sort();

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (let i = 0; i < keysA.length; i++) {
    if (keysA[i] !== keysB[i]) {
      return false;
    }

    if (!deepEquals(a[keysA[i]], b[keysA[i]])) {
      return false;
    }
  }

  return true;
}

export function formatNumber(number) {
  if (Number(number) >= 1000) {
    var units = ['', 'K', 'M', 'B', 'T']; // Add more units as needed
    var unitIndex = 0;
    while (number >= 1000) {
      number /= 1000;
      unitIndex++;
    }
    return number?.toFixed(2) + units[unitIndex];
  } else {
    return number?.toString();
  }
}
export function getValueBetweenParentheses(inputString) {
  const regex = /\((.*?)\)/; // Regular expression to match the content between parentheses
  const match = regex.exec(inputString);
  return match && match[1] ? match[1] : inputString;
}
export function ContainsArabic(text) {
  // Define a regular expression pattern for Arabic script characters
  var arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

  // Use the test method to check if the text contains Arabic characters
  return arabicPattern.test(text);
}

export function sortObjectByCategory(inputObject) {
  const sortedObject = {};
  Object.values(inputObject || {}).forEach(item => {
    if (!sortedObject[item.category]) {
      sortedObject[item.category] = { key: item.category, value: item.category, label: item.category, options: [item] };
    } else {
      sortedObject[item.category].options.push(item);
    }
  });

  return sortedObject;
}
export function getAllOptions(sortedObject) {
  const allOptions = [];

  Object.values(sortedObject).forEach(category => {
    allOptions.push(...category.options);
  });

  return allOptions;
}
export function filterSortedObject(sortedObject, selectedOptionIds) {
  const filteredObject = {};

  Object.keys(sortedObject || {})?.forEach(categoryKey => {
    const category = sortedObject[categoryKey];
    const filteredOptions = category?.options?.filter(option =>
      !selectedOptionIds?.includes(option.key)
    );

    if (filteredOptions.length > 0) {
      filteredObject[category.key] = { key: category.key, value: category.key, label: category.key, options: filteredOptions };
    }
  });

  return filteredObject;
}

export function filterAndSortObjectByCategory(inputObject, selectedOptionIds) {
  const resultObject = {};

  Object.values(inputObject || {}).forEach(item => {
    if (!resultObject[item.category]) {
      resultObject[item.category] = { key: item.category, value: item.category, label: item.category, options: [item] };
    } else {
      resultObject[item.category].options.push(item);
    }
  });

  const filteredObject = {};

  Object.keys(resultObject || {}).forEach(categoryKey => {
    const category = resultObject[categoryKey];
    const filteredOptions = category?.options?.filter(option =>
      !selectedOptionIds?.includes(option.key)
    );

    if (filteredOptions.length > 0) {
      filteredObject[category.key] = { key: category.key, value: category.key, label: category.key, options: filteredOptions };
    }
  });

  return filteredObject;
}

export const compareContacts = (a, b) => {

  // const itemExpirationA = a?.exp;
  // const itemExpirationB = b?.exp;

  const itemUpdatedA = a?.updated;
  const itemUpdatedB = b?.updated;

  // if (itemExpirationA > itemExpirationB) {
  //   return 1;
  // } else if (itemExpirationA < itemExpirationB) {
  //   return -1;
  // } else {
  // If the item expiration dates are the same, compare the last message's created property
  if (itemUpdatedA < itemUpdatedB) {
    return 1;
  } else if (itemUpdatedA > itemUpdatedB) {
    return -1;
  } else {
    return 0;
    // }
  }
};


export const SearchChats = async ({ searchText, user }) => {
  let ref = firestore().collection('chats')
  if (user?.accessType === 'admin') {
    ref = ref.where('provider_id', '==', user?.uid)
  }
  let nameSnapshot = await ref.where('name', '>=', searchText)
    .where('name', '<=', searchText + '\uf8ff') // For case-insensitive search
    .limit(3)
    .get();
  let numberQuery = await ref.where('wa_id', '>=', searchText)
    .where('wa_id', '<=', searchText + '\uf8ff') // For case-insensitive search
    .limit(3)
    .get();
  let docs = [...numberQuery.docs, ...nameSnapshot.docs];
  return docs
}

export const getBannerName = (banner, storeData = {}) => {
  const { services, advServices, provider } = storeData
  let name = ''

  switch (banner?.type) {
    case 'url':
    case 'navigation':
      name = banner.url
      break
    case 'service':
      // Look up service name by ID from services or advServices
      const allServices = { ...(services || {}), ...(advServices || {}) }
      const service = allServices[banner.service]
      name = service?.name || banner.service || 'Unknown Service'
      break
    case 'serviceProvider':
      // Look up service provider name by ID from provider
      const serviceProvider = provider?.[banner.serviceProvider]
      name = serviceProvider?.name || banner.serviceProvider || 'Unknown Provider'
      break
    default:
      name = banner.type || 'Unknown Type'
      break
  }
  return name
}

export async function createDynamicLink({ service, washingType }) {
  let link
  if (washingType === 'waterlessWash') {
    link = (`https://chillcarservices.page.link/?link=${encodeURIComponent(`https://chillapp.ae?route=${service?.key}&washingType=${washingType}`)}&apn=com.chillcarservices.app&isi=1550899765&ibi=com.chillapp.ios&utm_medium=share_service&st=${service?.name} 🎉&sd=book you services with Chillapp&si=${encodeURIComponent(service?.Service_image?.[0])}`)
  } else {
    link = (`https://chillcarservices.page.link/?link=${encodeURIComponent(`https://chillapp.ae?route=${service?.key}`)}&apn=com.chillcarservices.app&isi=1550899765&ibi=com.chillapp.ios&utm_medium=share_service&st=${service?.name} 🎉&sd=book you services with Chillapp&si=${encodeURIComponent(service?.Service_image?.[0])}`)
  }
  let results = await axios.post('https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyCExglJjHXgXzSGHJB1NmLll7NgjOG8_bc', {
    'longDynamicLink': link,
    "suffix": {
      "option": "SHORT"
    },

  })

  return results?.data?.shortLink
}
export async function createVoucherDynamicLink({ voucher }) {
  let { amount, numberOfSplits, minAmount, exp, key } = voucher
  const chillLogo = "https://firebasestorage.googleapis.com/v0/b/chill-wash.appspot.com/o/FCMImages%2F120.png?alt=media&token=69e3ba41-1805-45c6-83a5-e809f16efe7f";
  const title = `Claim Your AED ${amount} Discount Now!`
  const description = `Use this AED ${amount} voucher on your next Chillapp booking and experience premium service for less!`
  let link = (`https://chillcarservices.page.link/?link=${encodeURIComponent(`https://chillapp.ae?route=voucher&voucherID=${key}&voucherValue=${amount}&splits=${numberOfSplits}&minOrderValue=${minAmount}&expiry=${exp}`)}&apn=com.chillcarservices.app&isi=1550899765&ibi=com.chillapp.ios&utm_medium=share_voucher&st=${title} 🎉&sd=${description}&si=${encodeURIComponent(chillLogo)}`);
  let results = await axios.post('https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyCExglJjHXgXzSGHJB1NmLll7NgjOG8_bc', {
    'longDynamicLink': link,
    "suffix": {
      "option": "SHORT"
    },

  })

  return results?.data?.shortLink
}
// export async function createAppsFlyerVoucherDynamicLink({ voucher }) {
//   let { amount, numberOfSplits, minAmount, exp, key } = voucher
//   const baseURL = 'https://chillapp.onelink.me/AdVJ/?'
//   // AppsFlyer Open Graph parameters
//   const af_og_image = "https://firebasestorage.googleapis.com/v0/b/chill-wash.appspot.com/o/FCMImages%2F120.png?alt=media&token=69e3ba41-1805-45c6-83a5-e809f16efe7f";
//   const af_og_title = `Claim Your AED ${amount} Discount Now!`
//   const af_og_description = `Use this AED ${amount} voucher on your next Chillapp booking and experience premium service for less!`


//   let link = (`${baseURL}type=voucher&voucherID=${key}&voucherValue=${amount}&splits=${numberOfSplits}&minOrderValue=${minAmount}&expiry=${exp}&af_og_title=${encodeURIComponent(af_og_title)}&af_og_description=${encodeURIComponent(af_og_description)}&af_og_image=${encodeURIComponent(af_og_image)}`);

//   return link
// }
export async function createAppsFlyerVoucherDynamicLink({ voucher }) {
  let { amount, numberOfSplits, minAmount, exp, key } = voucher
  const baseURL = 'https://chillapp.onelink.me/AdVJ/?'

  // AppsFlyer Open Graph parameters
  const af_og_image = "https://firebasestorage.googleapis.com/v0/b/chill-wash.appspot.com/o/FCMImages%2F120.png?alt=media&token=69e3ba41-1805-45c6-83a5-e809f16efe7f";
  const af_og_title = `Claim Your AED ${amount} Discount Now!`
  const af_og_description = `Use this AED ${amount} voucher on your next Chillapp booking and experience premium service for less!`

  const longLink = `${baseURL}type=voucher&voucherID=${key}&voucherValue=${amount}&splits=${numberOfSplits}&minOrderValue=${minAmount}&expiry=${exp}&af_og_title=${encodeURIComponent(af_og_title)}&af_og_description=${encodeURIComponent(af_og_description)}&af_og_image=${encodeURIComponent(af_og_image)}`;

  // Use short.io to shorten the link
  try {
    const response = await fetch('https://api.short.io/links', {
      method: 'POST',
      headers: {
        authorization: process.env.REACT_APP_SHORTIO_API_KEY,
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        originalURL: longLink,
        domain: 'link.chillapp.ae', // Using default short.io domain
        linkType: 'random' // Generate random short links
      })
    });

    if (!response.ok) {
      throw new Error(`Short.io API error: ${response.status}`);
    }

    const data = await response.json();
    return data.shortURL || longLink; // Return shortened link or fallback to long link
  } catch (error) {
    console.error('Error shortening link with Short.io:', error);
    return longLink; // Fallback to long link if shortening fails
  }
}
export function requestPermission() {
  console.log('Requesting permission...');
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      console.log('Notification permission granted.');
    }
  })

}

export function FormatTimestamp(timestamp) {
  if (!timestamp) {
    return ''

  }
  if (timestamp.seconds) {
    timestamp = timestamp.seconds * 1000
  }
  const now = moment();
  const date = moment(timestamp);
  let formatedTime = date.format('hh:mm A')

  // Check if the date is today
  if (date.isSame(now, 'day')) {
    return `${formatedTime}`;
  }

  // Check if the date is yesterday
  if (date.isSame(now.clone().subtract(1, 'day'), 'day')) {
    // return `Yesterday ${formatedTime}`;
    return `Yesterday`;
  }

  // Format the date as you like (e.g., 'DD/MM/YYYY')
  // return date.format('DD MMM hh:mm a');
  return date.format('DD/MM/YYYY');
}

export function sanitizeString(str) {
  // Replace commas, newlines, and double quotes with spaces
  // These are common characters that can cause issues in CSV files
  if (!str) {
    return ''
  }
  return str.replace(/[,"\n\r]+/g, ' ');
}
export function getPaymentMethod({ paymentType, price }) {
  if (price?.code === 'wallet' && Number(price?.totalPrice) === 0) {
    return 'wallet';
  }
  if (price?.code === 'wallet' && Number(price?.totalPrice) > 0) {
    return 'wallet / online';
  }
  return paymentType;
}


export const getTitle = (transaction) => {
  switch (transaction.type) {
    case 'earning':
      return transaction.referal ? 'Referral Points' : 'Cashback Bonus';
    case 'refund':
      return 'Refunded Points';
    case 'credit':
      if (transaction?.transfered) {
        return 'Bank Transfer';
      }
      return 'Credit';
    case 'cashback':
      return 'Cashback Bonus';
    case 'bogo':
      if (transaction?.redeemed) {
        return 'BOGO Redeemed';
      }
      return 'BOGO';
    case 'voucher':
      if (transaction?.redeemed) {
        return `${transaction?.description || 'Voucher'} Redeemed`;
      }
      return transaction.description || 'Voucher';
    default:
      return 'Expenses';
  }
};

export const getDescription = (transaction) => {
  let exp = moment(GetEXP(transaction));
  if (['earning', 'credit', 'refund', 'voucher', 'cashback', 'bogo'].includes(transaction.type)) {
    if (transaction.redeemed) {
      return `Redeemed on ${moment(transaction.redeemed).format('DD, MMM YYYY')}`;
    } else if (transaction.transfered) {
      return `Transferred on ${moment(transaction.transfered).format('DD, MMM YYYY')}`;
    }
    return `Expires On ${exp.format('DD, MMM YYYY')}`;
  }
  return transaction.description;
};
export const GetEXP = (date) => {
  if (date?.exp) {
    return date?.exp
  }
  return moment(date?.created).add(3, 'months').valueOf()
}
export const getAmountColor = (transaction) => {
  return ['earning', 'refund', 'credit', 'voucher', 'cashback', 'bogo'].includes(transaction.type) && !transaction.redeemed && !transaction.transfered
    ? 'green'
    : '#F21F1F';
};

export const getAmountSign = (transaction) => {
  return ['earning', 'refund', 'credit', 'voucher', 'cashback', 'bogo'].includes(transaction.type) && !transaction.redeemed && !transaction.transfered
    ? '+'
    : '-';
};

/** Wallet amount display - handles bogo (percent) vs others (AED amount) */
export const getWalletAmountDisplay = (transaction) => {
  if (transaction?.type === 'bogo') {
    if (transaction?.redeemed && transaction?.redeemedAmount != null) {
      return `Redeemed: AED ${Number(transaction.redeemedAmount).toFixed(2)}`;
    }
    const cap = transaction.cap != null ? ` (max ${transaction.cap} AED)` : '';
    return `${transaction.percent ?? 0}% off${cap}`;
  }
  return `${getAmountSign(transaction)} AED ${Number(transaction?.amount || 0).toFixed(2)}`;
};

export const CalculatePoints = (snap) => {
  let sorted = snap.sort((a, b) => a.created - b.created);
  const result = sorted?.reduce((val, current) => {
    let { type, amount } = current;
    amount = amount * 1;
    let increment = ['credit', 'refund', 'earning', 'voucher', 'cashback'].includes(type);
    let exp = GetEXP(current);
    let expired = moment().isAfter(moment(exp)) && ['voucher'].includes(type);
    const bogoExpired = moment().isAfter(moment(exp)) && type === 'bogo';
    if (expired || bogoExpired || current?.transfered || current?.redeemed) {
      return val
    }
    if (type === 'bogo') {
      val.bogos.push(current);
      return val;
    }
    if (['earning', 'refund', 'expense', 'credit', 'cashback'].includes(type)) {
      if (increment) {
        val.expired.push({ exp: { start: current.created, end: exp }, amount, OA: amount, id: current.id, type });
      } else {
        //check if recored created stamp is less than 3 months
        let eligible = val.expired.filter(rec => moment(current.created).isBetween(moment(rec.exp.start), moment(rec.exp.end)));
        let balance = amount;
        eligible.map(rec => {
          let index = val.expired.findIndex(r => r.id === rec.id);
          if (balance >= val.expired[index].amount) {
            balance = balance - val.expired[index].amount;
            val.expired[index].amount = 0;
          } else {
            val.expired[index].amount = val.expired[index].amount - balance;
            balance = 0;
          }
          return rec; // Ensure a value is returned
        });
      }
    }

    if (['credit', 'redeemed'].includes(type)) {
      val.totalCredit = val.totalCredit + (increment ? amount : -amount);
    }
    if (['voucher'].includes(type)) {
      val.totalVouchers = val.totalVouchers + (increment ? amount : -amount);
      if (!current.redeemed) {
        val.vouchers.push(current)
      }
    }
    return val
  }, {
    totalCashback: 0,
    totalCredit: 0,
    totalVouchers: 0,
    vouchers: [],
    expired: [],
    bogos: [],
  });

  result.totalBogoCount = result.bogos?.length ?? 0;
  result.totalCashback = result.expired.reduce((total, rec) => {
    if (moment(rec.exp.end).isAfter(moment()) && !['credit'].includes(rec.type)) {
      total = total + rec.amount
    }
    return total
  }, 0);
  result.totalCashback = Math.max(0, result.totalCashback)
  result.totalCredit = Math.max(0, result.totalCredit)
  result.totalVouchers = Math.max(0, result.totalVouchers)

  result.total = result.totalCashback + result.totalCredit + result.totalVouchers;
  result.totalWasherTip = Number(result.totalCredit) * 0.9705
  result.totalCheckoutPoints = result.totalCashback;
  return result

}
export const Capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const validateNumber = (countryCode, customer_number) => {
  let number = String(customer_number).replace(/\s/g, '');

  if (String(number).startsWith("0")) {
    number = Number(customer_number)
  }

  if (String(number).startsWith("971")) {
    var temp = String(number).substring(3, String(number).length);
    number = temp;
  }
  return ('+' + countryCode + number)
}
export const checkPhoneNumberVisibility = async ({ request, waitingTime }) => {

  const checkShowCallNumber = (lastMessageData, customer_number) => {
    if (!lastMessageData || (lastMessageData?.role && !['admin', 'washer'].includes(lastMessageData?.role))) return false;
    if (lastMessageData?.from === customer_number || (lastMessageData?.template_name && lastMessageData?.template_name !== 'create_new_session')) {
      return false;
    }
    const messageAge = moment().diff(moment(lastMessageData.created), 'minutes');
    return messageAge >= waitingTime;
  };

  if (!request?.customer_number) {
    return { showNumber: false, chatExists: false };
  }

  const number = Number(validateNumber((request.country_code || '971'), request.customer_number));
  const chatDocRef = firestore().collection('chats').doc(String(number));

  try {
    const chatDoc = await chatDocRef.get();
    if (!chatDoc.exists) {
      return { showNumber: ['new', 'accepted', 'active']?.includes(request.status) ? true : false, chatExists: false };
    }

    const messagesSnapshot = await chatDocRef.collection('messages').orderBy('created', 'desc').limit(1).get();
    if (messagesSnapshot.empty) {
      return { showNumber: ['new', 'accepted', 'active']?.includes(request.status) ? true : false, chatExists: chatDoc.data().whatsappActive || false };
    }

    const lastMessageData = messagesSnapshot.docs[0].data();
    const showNumber = ['new', 'accepted', 'active']?.includes(request.status) ? checkShowCallNumber(lastMessageData, String(number)) : false;

    return { showNumber, chatExists: chatDoc.data().whatsappActive || false };
  } catch (error) {
    console.error('Error checking phone number visibility:', error);
    return { showNumber: true, chatExists: false };
  }
};


export const uploadFile = (files, ref, parentId, childId) => {
  const [{ name }] = files;
  const file = files?.[0]
  if (!file) return;
  const storageRef = storage().ref().child(ref).child(parentId).child(childId)
  const uploadTask = storageRef.put(file);

  uploadTask.on("state_changed",
    (snapshot) => { },
    (error) => {
      // alert(error);
    },
    () => {
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        firestore().collection(ref).doc(parentId).set({ [childId]: { name: name, license: downloadURL }, updated: Date.now() }, { merge: true })
      })
    }
  );
};

export const uploadPicture = ({ pictures, collection, parentId, childId, subCollection, documentID, type }) => {
  var metadata = {
    cacheControl: 'public,max-age=300',
    contentType: 'image/jpeg'
  };
  console.log(pictures, 'collectioncollection', collection);


  var storageRef = storage().ref().child(collection).child(parentId)
  pictures.forEach(element => {
    switch (type) {
      case 'subCollection':
        storageRef = storageRef.child(subCollection).child(documentID).child(childId).put(element.data, metadata);
        storageRef.on('state_changed', function (snapshot) {
        }, function (error) {
          // setLoading(false)

          // Handle unsuccessful uploads
        }, function () {
          storageRef.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            firestore().collection(collection).doc(parentId).collection(subCollection).doc(documentID).set({ [childId]: [downloadURL], updated: Date.now() }, { merge: true }).then(() => {
            })
          })
        })
        break;
      default:
        storageRef = storageRef.child(childId).put(element.data, metadata);
        storageRef.on('state_changed', function (snapshot) {
        }, function (error) {
          // setLoading(false)

          // Handle unsuccessful uploads
        }, function () {
          storageRef.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            firestore().collection(collection).doc(parentId).set({ [childId]: [downloadURL], updated: Date.now() }, { merge: true }).then(() => {
            })
          })
        })
        break;
    }

  });
};

// Handle provider creation with Firebase auth
export const handleProviderCreation = async (general, dispatch, UpdateItem, setLoading) => {
  try {
    // Validate required fields
    if (!general.email) {
      createNotification("error", "Email is required", "Validation Error");
      setLoading(false);
      return false;
    }

    if (!general.password || !general.confirmPassword) {
      createNotification("error", "Password and confirmation are required", "Validation Error");
      setLoading(false);
      return false;
    }

    if (general.password !== general.confirmPassword) {
      createNotification("error", "Password mismatch", "Validation Error");
      setLoading(false);
      return false;
    }

    // Create Firebase auth user
    const authUsers = functions().httpsCallable('setRoles');
    const result = await authUsers({
      email: general.email,
      pw: general.password,
      role: 'admin',
      displayName: general.name?.en || general.name
    });

    const { user, error } = result.data;

    if (error) {
      const errorCode = error.errorInfo?.code;
      if (errorCode?.includes('invalid-phone-number')) {
        createNotification("error", "Invalid phone number", "Authentication Error");
      } else if (errorCode?.includes('auth/phone-number-already-exists')) {
        createNotification("error", "This number already exists", "Authentication Error");
      } else if (errorCode?.includes('invalid-data')) {
        createNotification("error", "Please enter all required data", "Authentication Error");
      } else {
        createNotification("error", error.errorInfo?.message || "An error occurred", "Authentication Error");
      }
      setLoading(false);
      return false;
    }

    // Clean up password fields and update the document ID to use Firebase Auth UID
    delete general.password;
    delete general.confirmPassword;
    general.key = user.uid; // Use Firebase Auth UID as document ID

    // Update the activeItem with the new key so the regular submit process uses the correct ID
    dispatch(UpdateItem({ key: 'general', val: general }));

    return true; // Success

  } catch (error) {
    console.error('Error creating provider auth user:', error);
    createNotification("error", "Failed to create provider account", "Error");
    setLoading(false);
    return false;
  }
};


// Handle provider creation with Firebase auth
export const handleWasherCreation = async (general, dispatch, UpdateItem, setLoading) => {
  try {
    // Validate required fields
    if (!general.phoneNumber) {
      createNotification("error", "Phone number is required", "Validation Error");
      setLoading(false);
      return false;
    }

    if (!general.name) {
      createNotification("error", "Name is required", "Validation Error");
      setLoading(false);
      return false;
    }



    // Create Firebase auth user
    const authUsers = functions().httpsCallable('setRoles');
    const result = await authUsers({
      phoneNumber: general.phoneNumber,
      role: 'washer',
      displayName: general.name
    });

    const { user, error } = result.data;

    if (error) {
      const errorCode = error.errorInfo?.code;
      if (errorCode?.includes('invalid-phone-number')) {
        createNotification("error", "Invalid phone number", "Authentication Error");
      } else if (errorCode?.includes('auth/phone-number-already-exists')) {
        createNotification("error", "This number already exists", "Authentication Error");
      } else if (errorCode?.includes('invalid-data')) {
        createNotification("error", "Please enter all required data", "Authentication Error");
      } else {
        createNotification("error", error.errorInfo?.message || "An error occurred", "Authentication Error");
      }
      setLoading(false);
      return false;
    }

    // Clean up password fields and update the document ID to use Firebase Auth UID
    general.key = user.uid; // Use Firebase Auth UID as document ID
    general.UID = user.uid;
    general.uid = user.uid;

    // Update the activeItem with the new key so the regular submit process uses the correct ID
    dispatch(UpdateItem({ key: 'general', val: general }));

    return true; // Success

  } catch (error) {
    console.error('Error creating washer auth user:', error);
    createNotification("error", "Failed to create washer account", "Error");
    setLoading(false);
    return false;
  }
};

// Export providers to CSV
export const exportProviders = (providers, filename = 'ServiceProvidersList.csv') => {
  if (!providers || !providers.length) {
    console.warn('No providers data to export');
    return;
  }

  let prefix = "data:text/csv;charset=utf-8,";
  let header = "ID,Service provider,Email,Number,IBAN,Account Number,Account Name,Bank Name,Active";
  let csvContent = header + "\r\n";

  providers.forEach(item => {
    // Sanitize data to handle commas, quotes, and special characters
    const sanitizeField = (field) => {
      if (field === null || field === undefined) return '--';
      const str = String(field);
      // If field contains comma, quote, or newline, wrap in quotes and escape existing quotes
      if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    csvContent += [
      sanitizeField(item.uniqueID),
      sanitizeField(item.name),
      sanitizeField(item.email || '--'),
      sanitizeField(item.number || '--'),
      sanitizeField(item.bankDetails?.IBAN || '--'),
      sanitizeField(item.bankDetails?.accountNumber || '--'),
      sanitizeField(item.bankDetails?.accountName || '--'),
      sanitizeField(item.bankDetails?.branch || '--'),
      sanitizeField(item.active)
    ].join(',') + "\r\n";
  });

  // Create and trigger download
  const encodedUri = prefix + encodeURIComponent(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


export function createObjectsFromArray(stringsArray) {
  return stringsArray.map(str => ({ name: str, value: str, label: str, key: str, id: str }));
}

export const getCollectionName = (service) => {
  if (service.advservice) {
    return 'advServices'
  } else if (service.external) {
    return 'externalServices'
  } else {
    return 'services'
  }
}

// Validate global promocode: no other offer can be global for the same service(s). Returns { valid, message }.
export const validateGlobalPromocode = (currentPromocode, allPromocodes) => {
  const { global, sp_id, key, services = [] } = currentPromocode;
  if (!global || !sp_id) return { valid: true };

  const toServiceIds = (arr) =>
    (Array.isArray(arr) ? arr : []).map(s => (typeof s === 'string' ? s : s?.key)).filter(Boolean);

  const currentServiceIds = toServiceIds(services);
  // When global=true and no services selected: treat as "all services" - only one global per SP
  const checkAllServices = currentServiceIds.length === 0;

  const otherPromocodes = allPromocodes.filter(rec => rec.sp_id === sp_id && rec.key !== key);

  for (const other of otherPromocodes) {
    if (!other.global) continue;
    const otherServiceIds = toServiceIds(other.services);
    const otherCheckAll = otherServiceIds.length === 0;

    if (checkAllServices || otherCheckAll) {
      return {
        valid: false,
        message: `Another offer (${other.code || other.key}) is already auto-applied for this service provider. Each service can have only one auto-applied offer.`,
      };
    }
    const overlap = currentServiceIds.filter(sid => otherServiceIds.includes(sid));
    if (overlap.length > 0) {
      return {
        valid: false,
        message: `Another offer (${other.code || other.key}) is already auto-applied for the same service(s). Each service can have only one auto-applied offer.`,
      };
    }
  }
  return { valid: true };
};


function getNestedValue(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, part) => (acc != null ? acc[part] : undefined), obj);
}

export const checkIfDisabled = (data, required = []) => {
  let errors = {};
  let hasErrors = false;

  // If no required fields are specified, don't disable the button
  if (!required || required.length === 0) {
    return false;
  }

  // required can be strings (e.g. 'code') or objects with { path } for nested (e.g. { path: 'percentage.percent' })
  required.forEach(fieldKey => {
    const path = typeof fieldKey === 'object' && fieldKey.path != null ? fieldKey.path : fieldKey;
    const fieldValue = path.includes('.') ? getNestedValue(data, path) : data[path];
    var isArr = fieldValue instanceof Array;

    switch (typeof fieldValue) {
      case 'string':
        if (!fieldValue || (typeof fieldValue === 'string' && fieldValue.trim() === '')) {
          hasErrors = true;
          errors[path] = "Please fill the required fields";
        }
        break;
      case 'number':
        if (fieldValue === null || fieldValue === undefined || isNaN(fieldValue)) {
          hasErrors = true;
          errors[path] = "Please fill the required fields";
        }
        break;
      case 'object':
        if (fieldValue === null || fieldValue === undefined) {
          hasErrors = true;
          errors[path] = "Please fill the required fields";
        } else if (isArr && fieldValue.length === 0) {
          hasErrors = true;
          errors[path] = "Please fill the required fields";
        } else if (!isArr && fieldValue.en !== undefined) {
          // Handle multilingual objects
          if (!fieldValue.en || fieldValue.en.trim() === '') {
            hasErrors = true;
            errors[path] = "Please fill the required fields";
          }
        } else if (!isArr && Object.keys(fieldValue).length === 0) {
          hasErrors = true;
          errors[path] = "Please fill the required fields";
        }
        break;
      case 'undefined':
        hasErrors = true;
        errors[path] = "Please fill the required fields";
        break;
      default:
        if (!fieldValue) {
          hasErrors = true;
          errors[path] = "Please fill the required fields";
        }
        break;
    }
  });

  // Log errors for debugging
  if (hasErrors) {
    console.log('Validation errors:', errors);
  }

  // Return true to disable button when there are errors
  return hasErrors;
}


export function compareTimings(timings1, timings2) {
  for (let day in timings1) {
    // Check if the day exists in the second timings object
    if (!(day in timings2)) {
      return false;
    }

    // Check if the timings array has the same length
    if (timings1[day].timings.length !== timings2[day].timings.length) {
      return false;
    }

    // Check if each timing object has the same start and end times
    for (let i = 0; i < timings1[day].timings.length; i++) {
      const timing1 = timings1[day].timings[i];
      const timing2 = timings2[day].timings[i];

      if (timing1.startTime !== timing2.startTime || timing1.endTime !== timing2.endTime) {
        return false;
      }
    }

    // Check if the isOpen value is the same
    if (timings1[day].isOpen !== timings2[day].isOpen) {
      return false;
    }
  }

  // If all values are the same, return true
  return true;
}
export function compareServices(activeService1, activeService2) {
  // Check if the number of keys in the objects are different
  if (Object.keys(activeService1).length !== Object.keys(activeService2).length) {
    return false;
  }

  // Check if each key-value pair is identical in both objects
  for (let key in activeService1) {
    if (typeof activeService1[key] === 'object') {
      // Recursively compare sub-objects
      if (!compareServices(activeService1[key], activeService2[key])) {
        return false;
      }
    } else if (activeService1[key] !== activeService2[key]) {
      return false;
    }
  }

  // If all key-value pairs are identical, return true
  return true;
}